import React from 'react';

import { cn } from 'components/lib/utils';

export type RewardsLayoutValue = 1 | 2 | 3;

interface IRewardsLayoutOptionProps {
  value: RewardsLayoutValue;
  isSelected: boolean;
  onClick: (value: RewardsLayoutValue) => void;
  testId: string;
}

const RewardsLayoutOption: React.FC<IRewardsLayoutOptionProps> = ({
  value,
  isSelected,
  onClick,
  testId
}): React.ReactElement => {
  const handleClick = (): void => {
    onClick(value);
  };

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isSelected}
      aria-label={`${value} reward tiles`}
      className={cn(
        'flex gap-1 w-[80px] h-[38px] p-[10px] rounded-lg border border-base bg-base-background hover:shadow-md cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-base-ring',
        isSelected && 'border-base-black'
      )}
      onClick={handleClick}
      data-testid={testId}
    >
      {Array.from({ length: value }).map((_, index) => (
        <div key={index} className="w-full h-full bg-base-muted rounded-sm" />
      ))}
    </button>
  );
};

const REWARDS_LAYOUT_OPTIONS: RewardsLayoutValue[] = [3, 2, 1];

interface IRewardsLayoutPickerProps {
  value: RewardsLayoutValue;
  onChange: (value: RewardsLayoutValue) => void;
  testIdPrefix: string;
}

export const RewardsLayoutPicker: React.FC<IRewardsLayoutPickerProps> = ({
  value,
  onChange,
  testIdPrefix
}): React.ReactElement => {
  const labelId = `${testIdPrefix}-label`;

  return (
    <div className="flex flex-col gap-2">
      <div
        id={labelId}
        className="text-sm text-base-black text-left mt-1 mb-2"
      >
        Rewards Layout
      </div>
      <div
        role="radiogroup"
        aria-labelledby={labelId}
        className="flex justify-between items-center w-full text-base-mutedForeground text-xs leading-5 font-sans"
      >
        {REWARDS_LAYOUT_OPTIONS.map((option) => (
          <RewardsLayoutOption
            key={option}
            value={option}
            isSelected={value === option}
            onClick={onChange}
            testId={`${testIdPrefix}-${option}`}
          />
        ))}
      </div>
    </div>
  );
};
